<template>
  <div class="cat wrap">
    <div class="header">
      <NavBar
        title="Address"
        left-arrow
        @click-left="$router.go(-1)"
        class="no_bg"
      >
        <span slot="right" icon="cart-o" @click="$router.push('/address/add')"
          ><Icon name="plus"
        /></span>
      </NavBar>
    </div>
    <div class="main">
      <SwipeCell v-for="item in list" :key="item.customerAddrId">
        <!-- <template #left>
          <Button square type="primary" text="选择" />
        </template> -->
        <div class="catItme">
          <div class="check">
            <Checkbox
              @click="selectGoods(item)"
              v-model="item.checked"
              icon-size="24px"
            />
          </div>
          <div class="Product" @click.stop="toOrder(item)">
            <!-- <div class="imgBox"><img src="../../../public/img/REFERRALbg.png" alt=""></div> -->
            <div class="ProductText">
              <div class="name">
                <div>{{ item.receiverName }}</div>
                <div class="pdl5">{{ item.phone }}</div>
                <!-- 默认标签 -->
                <Tag v-if="item.isDefault == 0" type="primary">default</Tag>
              </div>
              <div class="StepperBox">
                <div class="PriceX">
                  {{ item.street }}
                </div>
                <div><Icon name="edit" @click.stop="edit(item)" /></div>
              </div>
            </div>
          </div>
        </div>
        <template #right>
          <Button square type="danger" text="delete" @click="del(item)" />
        </template>
      </SwipeCell>
      <!-- <div class="buyBox">
        <Button color="#16C7CE" type="primary" @click="$router.push('/order')"  block >确认默认地址返回订单页</Button>
      </div> -->
    </div>
  </div>
</template>
<script>
import request from "../../api/request";
import { Notify, Toast } from "vant";
import { getStore, setStore } from "../../utils/storage";
import store from "../../store/index";
export default {
  data() {
    return {
      checked: false,
      value: 1,
      list: []
    };
  },
  created() {
    this.pull();
  },

  methods: {
    pull() {
      let data = { page: 1, limit: 10 };
      request("get", "cms/customeraddr/list", data).then(res => {
        if (res.code === 200) {
          this.list = res.data.list;
        }
      });
    },
    del(item) {
      let data = { customerAddrIds: item.customerAddrId };
      request("delete", "cms/customeraddr/delete", data).then(res => {
        if (res.code === 200) {
          //  this.$toast.success('删除成功')
          Notify({ type: "success", message: "successfully deleted" });
          this.pull();
        }
      });
    },
    edit(item) {
      this.$router.push({
        path: "/address/add",
        query: {
          customerAddrId: item.customerAddrId
        }
      });
    },

    toOrder(item) {
      setStore("Address", item); //  存储列表点击地址信息
      this.$router.push('/order?'+ getStore('orderHttp'))
      // this.$router.go(-1);
    },

    selectGoods(item) {
      this.list.forEach(i => {
        if (item.customerAddrId == i.customerAddrId && i.checked) {
          i.checked = true;
        } else {
          i.checked = false;
        }
      });
      this.list.push("");
      this.list.pop();
    }
  }
};
</script>
<style lang="less" scoped>
.cat {
  .main {
    margin-bottom: 100px;
    display: flex;
    flex-flow: column;
    overflow: hidden;
  }
  background: #f6f8fa;
  .catItme {
    background: #fff;
    display: flex;
    // height:86px ;
    padding: 10px 0;
    margin-bottom: 10px;
    .check {
      width: 15%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .Product {
      flex: 1;
      display: flex;
      .ProductText {
        padding: 0 10px;
        flex: 1;
        display: flex;
        flex-flow: column;
        justify-content: space-around;
        text-align: left;
        font-size: 15px;
        .name {
          display: flex;
          align-items: center;
          line-height: 30px;
          font-weight: bold;
        }
        .ProductDes {
          font-size: 13px;
          color: #9ba1aa;
          padding-top: 5px;
        }
        .StepperBox {
          display: flex;
          justify-content: space-between;
          align-items: center;
          .PriceX {
            padding-right: 10px;
          }
        }
      }
    }
    .pdl5 {
      padding: 0 5px;
    }
  }
  .buyBox {
    padding: 10px;
    position: absolute;
    height: 100px;
    background: #fff;
    width: 100%;
    left: 0;
    bottom: 0;
    box-sizing: border-box;
    display: flex;
    flex-flow: column;
    justify-content: space-around;
  }
}
</style>
<style>
.cat .van-swipe-cell .van-button {
  height: 100%;
}
</style>
